import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { deleteBannerById, getBanners, updateBanner } from '@/api/banner';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Enabled from '@/components/Enabled/index.vue';
import { AdminModule } from '@/store/modules/admin';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.role = AdminModule.roles;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      sort: 'priority,ASC',
      filter: {
        enabled: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
    this.pageOptions = {
      Category: 'Category',
      Product: 'Product',
      'External Link': 'External Link'
    };
  }
  activated() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getBanners(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async updatePriority(row) {
    try {
      const data = await updateBanner(row.id, {
        priority: row.priority
      });
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDelete(data) {
    if (data) {
      this.$confirm(this.$tc('table.deleteConfirmation', 0, {
        name: data.id
      }), this.$tc('table.delete'), {
        confirmButtonText: this.$tc('table.delete'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: this.$tc('table.cancel'),
        type: 'error'
      }).then(() => {
        deleteBannerById(data.id).then(deleted => {
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$tc('table.deleteCanceled')
        });
      });
    }
  }
  getDateRangeColor(data) {
    if (data.validFrom && data.validTill) {
      const validFrom = this.$moment(data.validFrom);
      const validTill = this.$moment(data.validTill);
      const now = this.$moment();
      // check if not yet started
      if (now > validTill) {
        return 'danger';
      } else if (now >= validFrom && now <= validTill) {
        return 'success';
      } else if (validFrom > now) {
        return 'primary';
      }
    }
    return 'info';
  }
};
default_1 = __decorate([Component({
  name: 'BannerList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;